import { createFileRoute, redirect } from '@tanstack/react-router'

import { getCurrentSKU } from '@/shared/auth/store'
import { redirectHome } from '@/shared/routing/utils/redirect'

export const Route = createFileRoute('/_dashboard/mdr/')({
	beforeLoad: () => {
		const sku = getCurrentSKU()

		// Only redirect if the SKU is MDR enabled
		if (sku && sku.is_mdr_enabled) {
			throw redirect({ to: '/mdr/executive-reports' })
		} else {
			redirectHome()
		}
	},
	head: () => ({
		meta: [
			{
				title: 'MDR | BitLyft AIR®',
			},
		],
	}),
})
